export const GET_REVISIONS = "app/REVISIONS/GET_REVISIONS";
export const GET_REVISIONS_SUCCESS = "app/REVISIONS/GET_REVISIONS_SUCCESS";
export const GET_REVISIONS_FAILURE = "app/REVISIONS/GET_REVISIONS_FAILURE";

export const SET_REVISION_STEP = "app/REVISIONS/SET_REVISION_STEP";
export const SET_REVISION_FIELDS = "app/REVISIONS/SET_REVISION_FIELDS";
